import axios from 'axios';
const client = axios.create();

client.defaults.baseURL = process.env.REACT_APP_API_URL;
client.defaults.headers.common['Content-Type'] = 'application/json';
client.defaults.timeout = 200000;
client.defaults.headers.common['Authorization'] = localStorage.getItem('token');

client.interceptors.request.use(function (config) {
    // console.log(" interceptor -> " + localStorage.getItem('token'))
    config.headers.Authorization = localStorage.getItem('token')
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

/*
//글로벌 설정 예시:


// 헤더 설정
client.defaults.headers.common['Authorization'] = 'Bearer a1b2c3d4';

// 인터셉터 설정
axios.intercepter.response.use(\
    response => {
        // 요청 성공 시 특정 작업 수행
        return response;
    },
    error => {
        // 요청 실패 시 특정 작업 수행
        return Promise.reject(error);
    }
  })
  */


export default client;
